"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BizDevBaseEntity = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const transformToDate_1 = require("../transformers/transformToDate");
class BizDevBaseEntity {
    _id = (0, uuid_1.v4)();
    createdAt = new Date();
    updatedAt = new Date();
}
exports.BizDevBaseEntity = BizDevBaseEntity;
__decorate([
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, typeorm_1.ObjectIdColumn)(),
    __metadata("design:type", String)
], BizDevBaseEntity.prototype, "_id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Date),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], BizDevBaseEntity.prototype, "createdAt", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    (0, typeorm_1.UpdateDateColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => Date),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], BizDevBaseEntity.prototype, "updatedAt", void 0);
//# sourceMappingURL=BizDevBaseEntity.js.map